import React from "react";
import MuiDataGrid from "./MuiDataGrid.js";
const withDataGridClient = (WrappedDataGrid) => (props) => {
  const { rows } = props;
  return /* @__PURE__ */ React.createElement(WrappedDataGrid, { ...props, rowCount: rows?.length, sortingMode: "client", paginationMode: "client" });
};
const MuiDataGridClient = withDataGridClient(MuiDataGrid);
export {
  MuiDataGridClient
};
//# sourceMappingURL=MuiDataGridClient.js.map
